/**
 *  VUE MIXIN - help share same logic in many components
 *  @example: in Vue component u have to import mixins using import {} from '';,
 *  and register yours mixin in component mixin: [ importedMixin ];
 *  @see https://vuejs.org/v2/guide/mixins.html
 *  @see https://www.vuemastery.com/courses/next-level-vue/mixins/
 *  @type {{data(): {isConfectionModalOpen: boolean}, methods: {handleModalOpen(): void}}}
 *  @description This mixin provide logic to control modal visibility and provide correct modal type
 */

import { modalType } from './modalType';

export const confectionModalMixin = {
  data() {
    return {
      modalType,
      isConfectionModalOpen: false,
    };
  },
  methods: {
    handleModalOpen() {
      this.isConfectionModalOpen = !this.isConfectionModalOpen;
    },
  },
};
